import { Input, Select, Space } from 'antd'

import { SupplyDemandType } from '@eastcoal/shared/enums/SupplyDemandType'

import { SupplyDemandTelehoneInputProps } from './interface'

const options = [
  {
    label: '需求',
    value: SupplyDemandType.DEMAND
  },
  {
    label: '供应',
    value: SupplyDemandType.SUPPLY
  }
]

export const SupplyDemandTelehoneInput = ({
  value,
  onChange,
  ...restProps
}: SupplyDemandTelehoneInputProps) => {
  return (
    <Space.Compact style={{ width: '100%' }}>
      <Select
        {...restProps}
        allowClear={false}
        options={options}
        placeholder='请选择供需类型'
        value={value.type}
        style={{
          flex: '0 0 120px'
        }}
        onChange={type =>
          onChange({
            ...value,
            type
          })
        }
      />
      <Input
        {...restProps}
        placeholder='请输入您的联系电话号码...'
        value={value.telephone}
        onChange={e =>
          onChange({
            ...value,
            telephone: e.target.value
          })
        }
      />
    </Space.Compact>
  )
}
